import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "App-User-Education" }
const _hoisted_2 = { "m-tb-0": "" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  "m-tb-0": ""
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_section_divider, { content: "Education" }, _createSlots({
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "el-icon-postcard" }, null, -1))
      ]),
      _: 2
    }, [
      (_ctx.isSelf)
        ? {
            name: "action",
            fn: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addEducation())),
                class: "el-icon-edit",
                circle: "",
                size: "mini"
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    (_ctx.user.education === undefined || _ctx.user.education.length === 0)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          image: _ctx.img
        }, {
          description: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("h2", { "m-tb-0": "" }, "Oops!", -1),
            _createElementVNode("p", null, [
              _createTextVNode(" No Education information "),
              _createElementVNode("br"),
              _createTextVNode(" for this user was found ")
            ], -1)
          ]))]),
          default: _withCtx(() => [
            (_ctx.isSelf)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _ctx.addEducation,
                  "is-borderless": "",
                  plain: "",
                  type: "primary",
                  icon: "el-icon-plus",
                  size: "large"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Add Education Information ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["image"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_timeline, { "m-t-3": "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.education, (edu, index) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: `education-${index}`,
                size: "large",
                center: true,
                placement: "bottom"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_2, [
                      (edu.degree)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(edu.degree) + ", ", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(edu.program), 1)
                    ]),
                    (edu.organisation && edu.organisation.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(edu.organisation.name), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, [
                        (edu.from)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$moment(edu.from).format("MMM yy")), 1))
                          : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createElementVNode("span", null, " - ", -1)),
                        (edu.to)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$moment(edu.to).format("MMM yy")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, "Present"))
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}